
import { useState, useEffect } from 'react';
import { useQuery } from '@tanstack/react-query';
import { useSession } from '@supabase/auth-helpers-react';
import { supabase } from '@/integrations/supabase/client';

export const useUserProfile = () => {
  const [userPlan, setUserPlan] = useState<'FREE' | 'UNLIMITED'>('FREE');
  const session = useSession();

  // Fetch user profile to get plan information
  const { data: profile } = useQuery({
    queryKey: ["profile"],
    queryFn: async () => {
      if (!session?.user?.id) return null;

      const { data, error } = await supabase
        .from("profiles")
        .select("plan")
        .eq("id", session.user.id)
        .single();

      if (error) {
        console.error('Error fetching profile:', error);
        return null;
      }
      
      return data;
    },
    enabled: !!session?.user?.id,
  });

  // Update user plan when profile data changes
  useEffect(() => {
    if (profile?.plan) {
      setUserPlan(profile.plan as 'FREE' | 'UNLIMITED');
    } else if (!session?.user?.id) {
      setUserPlan('FREE');
    }
  }, [profile, session]);

  return {
    userPlan,
    profile,
    session
  };
};
